import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CipaElectionHistoryItemDto, CipaElectionHistoryResponseDto } from './election-history.models';

@Injectable({
  providedIn: 'root',
})
export class ElectionHistoryService {
  private readonly baseUrl = `${environment.smocipaApiBaseUrl}/cipa/voting/elections`;

  constructor(private readonly http: HttpClient) { }

  getElectionHistory(): Observable<CipaElectionHistoryItemDto[]> {
    return this.http
      .get<CipaElectionHistoryResponseDto>(`${this.baseUrl}/history`)
      .pipe(map((response) => response.items));
  }
}
